import { LoadingButton } from '@mui/lab'
import { Stack, TextField } from '@mui/material'
import React from 'react'

import { useTranslation } from 'hooks/use-translation'

export const MonitorSearchField: React.FC<{
  value: string
  onChange(value: string): void
  onSubmit(): void
  disabled?: boolean
  isLoading?: boolean
  label?: string
}> = ({
  value,
  onChange,
  onSubmit,
  label,
  disabled = false,
  isLoading = false,
  ...rest
}) => {
  const { trans } = useTranslation()

  return (
    <Stack direction="row" gap={2}>
      <TextField
        disabled={disabled}
        inputProps={{ 'data-test-status-check-search-input': true }}
        label={label || trans('status_checks.monitors.search')}
        size="small"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault()
            onSubmit()
          }
        }}
        {...rest}
      />
      <LoadingButton
        data-test-status-check-search-submit
        disabled={disabled || !value?.trim()}
        loading={isLoading}
        size="small"
        variant="contained"
        onClick={onSubmit}
      >
        {trans('status_checks.monitors.search')}
      </LoadingButton>
    </Stack>
  )
}
